import Cookies from 'js-cookie';

// Supabase owns the active session. Remove cookies created by older releases,
// but never duplicate access tokens or user profiles into JavaScript cookies.
export const removeLegacyAuthCookies = () => {
    Cookies.remove('auth_token');
    Cookies.remove('user_data');
};
